import { default as default2 } from "./components/modules/menu-item/components/WishlistMenuItemContainer.js";
export {
  default2 as WishlistMenuItem
};
//# sourceMappingURL=menu-item.js.map
